import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';

/**
 * @class PhoneLinkUtility
 */
class PhoneLinkUtility {
  /**
   * @name constructor
   * @returns {void}
   */
  constructor() {
    this.dataAttrib = 'data-phone-link-id';
    this.cachedLinks = [];
  }

  /**
   * Updates telephone links based on viewport and available telephone links.
   * @name updateTelLinks
   * @returns {void}
   */
  updateTelLinks() {
    if (!this.isMobileViewport()) {
      const links = [...document.querySelectorAll('a[href^="tel:"]')];
      links.forEach((link, index) => {
        const span = document.createElement('span');
        span.classList.add('phone-link-utility-phone-link');
        let textContent = link.innerText;
        const adaSpan = link.querySelector('.ada-hidden,ADA');
        if (adaSpan) {
          textContent = textContent.replace(adaSpan.innerText, '');
        }
        span.append(textContent);

        // Unfortunately, we can't assume the element will have a UNIQUE id
        span.setAttribute(this.dataAttrib, index);
        span.setAttribute('data-id', link.id);
        link.getAttributeNames().forEach(attrib => {
          span.setAttribute(attrib, link.getAttribute(attrib));
        });
        this.cachedLinks.push(link);
        link.parentNode.replaceChild(span, link);
      });
    } else {
      this.cachedLinks.forEach((link, index) => {
        const replaceLink = document.querySelector(`span[${this.dataAttrib}="${index}"]`);
        if (replaceLink.parentNode) {
          replaceLink.parentNode.replaceChild(link, replaceLink);
        }
      });
      this.cachedLinks = [];
    }
  }

  /**
   * @name isMobileViewport
   * @returns {boolean}
   */
  isMobileViewport() {
    return spartaMediaQueryUtility.getCurrentViewport().currentViewport.indexOf('small') > -1;
  }

  /**
   * @name run
   * @returns {void}
   */
  run() {
    spartaEventsUtility.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, () => {
      this.updateTelLinks();
    });
    document.addEventListener('DOMContentLoaded', () => {
      this.updateTelLinks();
    });
  }
}
var index = new PhoneLinkUtility();

export { index as default };
